/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
// Configura el axios global (timeout + interceptors de sesion/red) para toda la app.
import "./http";
import axios from "./axios.js"
Vue.prototype.$http = axios

// lodash
import _ from 'lodash';

// Theme Configurations
import '../themeConfig.js'
import { colors } from '../themeConfig.js'

// Color de marca disponible como `$brandColor` en cualquier template. El hex estaba
// repetido en 5 componentes (props de <spinner>, que no pueden leer una variable de
// SCSS); ahora sale de themeConfig, el unico lugar donde se declara la paleta.
Vue.prototype.$brandColor = colors.success


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
/* import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate) */

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
